export default "__VITE_ASSET__B$bJQGxp__"